import { Injectable } from '@angular/core';

import { AccountLicenseService } from 'rev-shared/security/AccountLicense.Service';
import { MediaFeaturesService } from 'rev-shared/media/MediaFeatures.Service';
import { SecurityContextService } from 'rev-shared/security/SecurityContext.Service';

@Injectable({
	providedIn: 'root'
})
export class RevIQService {

	constructor(
		private readonly MediaFeaturesService: MediaFeaturesService,
		private readonly accountLicense: AccountLicenseService,
		private readonly SecurityContext: SecurityContextService
	) { }

	public isRevIQEligible(accountId: string): Promise<boolean> {
		return this.MediaFeaturesService.getFeatures(accountId)
			.then(features => features.transcriptionSettings?.isEnabledRevTranscription);
	}

	public isRevIQAuthorized(): boolean {
		return this.SecurityContext.checkAuthorization('media.useRevIq');
	}

	public isRevIQCreditsValid(): Promise<boolean> {
		return this.accountLicense.updateLicenseHoursValid().then(() => this.accountLicense.aiCreditsValid);
	}

	public isRevIQEligibleAndAuthorized(accountId: string): Promise<boolean> {
		return this.isRevIQEligible(accountId)
			.then(isRevIQEligible => isRevIQEligible && this.isRevIQAuthorized());
	}

	public isRevIQEligibleWithValidAiCredits(accountId: string): Promise<boolean> {
		return Promise.all([
			this.isRevIQEligibleAndAuthorized(accountId),
			this.isRevIQCreditsValid()
		])
			.then(([isRevIQEligible, creditsValid]) => creditsValid && isRevIQEligible);
	}

	public isRevIQAuthorizedWithValidAiCredits(): Promise<boolean> {
		return this.isRevIQCreditsValid()
			.then(creditsValid => creditsValid && this.isRevIQAuthorized());
	}
}
